import React from 'react';
import { SvgIcon } from '@mui/material';

function InboxIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 122 104">
      <path
        d="M77.3199 56.8101C77.3199 56.8101 74.6399 73.7601 60.4899 73.7601H60.1599C45.8299 73.5301 43.2599 56.8101 43.2599 56.8101H0.879883V103.53H121.11V56.8101H77.3199ZM113.39 96.0301H8.60988V64.3101H37.4199C40.4799 72.0401 47.3399 81.0301 60.0099 81.2601H60.4999C73.1999 81.2601 80.1099 72.1601 83.1999 64.3101H113.4V96.0301H113.39Z"
        fill="currentColor"
      />
      <path
        d="M58.3601 55.84C59.0301 56.47 59.9101 56.81 60.8601 56.81C61.2201 56.81 61.5801 56.75 61.8201 56.7C62.5101 56.59 63.1301 56.24 63.6501 55.73L80.8401 39.07C81.5101 38.38 81.8701 37.52 81.8701 36.61C81.8701 35.7 81.5101 34.83 80.8401 34.21C79.4501 32.84 77.2001 32.84 75.8101 34.21L64.6801 45.03V3.91998C64.6801 2.02998 63.0801 0.47998 61.1201 0.47998C59.1601 0.47998 57.5601 2.02998 57.5601 3.91998V45.37L46.1501 34.26C44.8101 32.94 42.4901 32.94 41.1501 34.26C40.4801 34.89 40.1201 35.75 40.1201 36.72C40.1201 37.64 40.4801 38.5 41.1501 39.12L58.3301 55.84H58.3601Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default InboxIcon;
